export const getExchangeRate = async ({ fromCurrency, toCurrency }) => {
  if (!fromCurrency || !toCurrency) {
    throw new Error('fromCurrency and toCurrency are required');
  }

  if (fromCurrency === toCurrency) {
    return 1;
  }

  try {
    const url = `https://openexchangerates.org/api/latest.json?app_id=975a0223154c40239d3879d0dc97d450&symbols=CAD`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Currency API request failed with status ${response.status}`);
    }

    const data = await response.json();

    if (!data || !data.rates || !data.base) {
      throw new Error('Invalid currency API response format');
    }

    if (fromCurrency === 'USD' && toCurrency === 'CAD') {
      const rate = data.rates.CAD;
      if (!rate || typeof rate !== 'number' || rate <= 0) {
        throw new Error('Invalid CAD exchange rate in API response');
      }
      return rate;
    }

    if (fromCurrency === 'CAD' && toCurrency === 'USD') {
      const rate = data.rates.CAD;
      if (!rate || typeof rate !== 'number' || rate <= 0) {
        throw new Error('Invalid CAD exchange rate in API response');
      }
      return 1 / rate;
    }

    throw new Error(`Unsupported currency conversion: ${fromCurrency} to ${toCurrency}`);
  } catch (error) {
    throw new Error(`Failed to get exchange rate: ${error.message}`);
  }
};

export const convertAmount = async ({ amount, fromCurrency, toCurrency }) => {
  const rate = await getExchangeRate({ fromCurrency, toCurrency });
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
  return safeAmount * rate;
};

export default {
  getExchangeRate,
  convertAmount,
};
